var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{opacity:0;}")),React.createElement("rect",{"className":"a","width":"24","height":"24","key":1}),React.createElement("path",{"d":"M12,21a1,1,0,0,1-.71-.29L3.52,12.93a5.233,5.233,0,1,1,7.4-7.4L12,6.61l1.08-1.08a5.233,5.233,0,1,1,7.4,7.4l-7.77,7.78A1,1,0,0,1,12,21ZM7.22,6a3.2,3.2,0,0,0-2.28.94,3.24,3.24,0,0,0,0,4.57L12,18.58l7.06-7.07a3.24,3.24,0,0,0,0-4.57,3.32,3.32,0,0,0-4.56,0l-1.79,1.8a1,1,0,0,1-1.42,0L9.5,6.94A3.2,3.2,0,0,0,7.22,6Z","key":2})]);
}

Heart.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Heart;

Heart.default = Heart;
